
export function excludeFrom(arr, ...exclusions) {
  const result = arr.filter((a) => !exclusions.includes(a));
  return Object.isFrozen(arr) ? Object.freeze(result) : result;
}